module.exports = __webpack_public_path__ + "static/img/ipad-first-view.c6f269e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ipad-first-view.png
// module id = KOAz
// module chunks = 1